export default __webpack_public_path__ + "static/media/2.db22f1f6.png";